import { InspectionCompletedEventSchema, InspectionEndedEventSchema, InspectionStartedEventSchema, } from '@eigtech/inspections-types';
import { z } from 'zod';
export const InspectionsInspectionTimelineEventSchema = z.union([
    InspectionStartedEventSchema,
    InspectionEndedEventSchema,
    InspectionCompletedEventSchema,
]);
export const InspectionsChronicleTypeSchema = z.enum([
    'inspectionStarted',
    'inspectionEnded',
    'inspectionReviewed',
]);
export const InspectionsChronicleType = InspectionsChronicleTypeSchema.enum;
